var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationsInSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.7,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "currentColor",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 12.017039 5.186077 C 9.532666 5.186077 7.517042 7.201701 7.517042 9.686075 L 7.517042 11.855108 C 7.517042 12.311073 7.316758 13.009937 7.090906 13.393459 L 6.221588 14.829538 C 5.69744 15.715901 6.059656 16.691753 7.035508 17.028401 C 10.26562 18.106525 13.759936 18.106525 16.985787 17.028401 C 17.893457 16.730105 18.294025 15.656242 17.795446 14.829538 L 16.934651 13.393459 C 16.71306 13.009937 16.517037 12.311073 16.517037 11.855108 L 16.517037 9.686075 C 16.517037 7.205962 14.488629 5.186077 12.017039 5.186077 Z M 12.017039 5.186077 ",
    transform: "matrix(0.916667,0,0,0.916667,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "currentColor",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 13.401982 5.403406 C 13.171868 5.330963 12.933232 5.279827 12.681812 5.249997 C 11.965903 5.160509 11.275563 5.215906 10.627836 5.403406 C 10.845165 4.845168 11.386358 4.453123 12.012778 4.453123 C 12.64346 4.453123 13.184652 4.845168 13.401982 5.403406 Z M 13.401982 5.403406 ",
    transform: "matrix(0.916667,0,0,0.916667,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.7,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "currentColor",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 14.262777 17.296866 C 14.262777 18.532661 13.252834 19.546865 12.012778 19.546865 C 11.394881 19.546865 10.82812 19.291184 10.42329 18.886354 C 10.018461 18.481525 9.762779 17.910502 9.762779 17.296866 ",
    transform: "matrix(0.916667,0,0,0.916667,0,0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsInSettings);
export default __webpack_public_path__ + "static/media/notifications-in-settings.b3bfc6db2849b7af992a1103c0eae42b.svg";
export { ForwardRef as ReactComponent };